<template>
    <div class="brush" :class="classes">
        <svg :width="svgWidth" :height="svgHeight" :viewbox="`0 0 ${svgWidth} ${svgHeight}`">
            <slot name="path"></slot>

            <defs>
                <!-- Animation du gradient -->
                <linearGradient id="gradient-hero" gradientUnits="userSpaceOnUse"
                                x1="-603.3042" y1="-0.1166" x2="-603.3042" y2="0.8833"
                                gradientTransform="matrix(416.5856 -14.5475 51.3235 1469.713 251542.1875 -8597.6035)">
                    <stop offset="0" style="stop-color:#D06E00">
                        <animate attributeName="stop-color"
                                 values="#D06E00; #F8AE35; #D06E00" dur="4s"
                                 repeatCount="indefinite"></animate>
                    </stop>
                    <stop offset="1" style="stop-color:#F8AE35">
                        <animate attributeName="stop-color"
                                 values="#F8AE35; #D06E00; #F8AE35" dur="4s"
                                 repeatCount="indefinite"></animate>
                    </stop>
                </linearGradient>

            </defs>
        </svg>
    </div>
</template>

<script>
    export default {
        name: "Brush",
        props:{
            classes:{
                type: String,
                default: ''
            },
            svgWidth:{
                type: Number,
                default: 0
            },
            svgHeight:{
                type: Number,
                default: 0
            }
        }
    }
</script>

<style scoped>

</style>
